'use client';

import { Button } from 'primereact/button'

export const DropzoneUpload = () => {
    return (
        <div className='text-center mt-2'>
            <Button type='button' label="Click here to Upload" className='no-underline' size='small' text raised={false}/>
        </div>
    )
}